"use client";
import { jsx as l } from "react/jsx-runtime";
import { IntelligentFormPrimitive as o } from "@inkeep/cxkit-primitives";
import { cn as n } from "../utils.js";
import { button as a } from "../ui/recipes/button.js";
import { checkbox as i } from "../ui/recipes/checkbox.js";
import { input as s } from "../ui/recipes/input.js";
import { select as r } from "../ui/recipes/select.js";
import { merge as m } from "merge-anything";
import { markdownStyles as d } from "../ui/markdown-styles.js";
const y = (e) => /* @__PURE__ */ l(o.Provider, { ...e }), N = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l(
  o.Root,
  {
    className: n(
      "max-w-full border divide-y",
      "rounded-xl shadow h-full max-h-full",
      "bg-white dark:bg-gray-dark-950",
      "flex flex-col",
      e
    ),
    ...t
  }
), b = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l(
  o.Heading,
  {
    className: n("px-5 py-4 font-medium shrink-0", e),
    ...t
  }
), C = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l(
  o.Content,
  {
    className: n("flex-1 overflow-hidden", e),
    ...t
  }
), w = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l(o.ContentScrollArea, { className: n("h-full", e), ...t }), k = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l(
  o.ContentScrollAreaViewport,
  {
    className: n(
      "h-full w-full rounded-[inherit] px-5",
      // We want to target the inner grid
      "[&_[data-part=grid]]:px-1",
      "[&_[data-part=grid]]:divide-y",
      e
    ),
    ...t
  }
), A = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l(
  o.ContentScrollAreaScrollbar,
  {
    className: n(
      "flex select-none touch-none p-0.5",
      "transition-colors duration-[160ms] ease-in-out",
      "w-2.5 border-l border-l-transparent",
      e
    ),
    ...t
  }
), B = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l(
  o.ContentScrollAreaThumb,
  {
    className: n("relative flex-1 rounded-full", "bg-gray-300 dark:bg-white-alpha-200", e),
    ...t
  }
), T = o.ContentScrollAreaCorner, P = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l(
  o.Success,
  {
    className: n("flex flex-col items-center", "justify-center mx-1 pt-12 pb-6", e),
    ...t
  }
), v = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l(
  o.SuccessIcon,
  {
    className: n("w-6 h-6 text-green-500 mb-5", e),
    ...t
  }
), H = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l(
  o.SuccessHeading,
  {
    className: n("text-xl font-semibold", "mb-3 tracking-tight", e),
    ...t
  }
), R = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l(
  o.SuccessMessage,
  {
    className: n("text-gray-800 dark:text-white-alpha-950", e),
    ...t
  }
), L = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l(
  o.PrimaryForm,
  {
    className: n("w-full flex flex-col py-6", e),
    ...t
  }
), E = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l(
  o.PrimaryFormDescription,
  {
    className: n("text-gray-700 dark:text-white-alpha-700 text-sm", e),
    ...t
  }
), V = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l(
  o.PrimaryFormFields,
  {
    className: n("w-full gap-8", e),
    ...t
  }
), z = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l(
  o.PrimaryFormSubmit,
  {
    className: n(
      a({ preset: "neutralFilled", size: "sm" }),
      "ml-auto data-[loading]:cursor-wait",
      "data-[submitted]:hidden",
      e
    ),
    ...t
  }
), q = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l(
  o.FormField,
  {
    className: n(
      "mb-8 flex flex-col gap-2 data-[hidden]:hidden",
      "data-[input-type=checkbox]:flex-row data-[input-type=checkbox]:items-center",
      e
    ),
    ...t
  }
), D = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l(
  o.FormFieldLabel,
  {
    className: n(
      "font-medium text-sm text-gray-700",
      "dark:text-white-alpha-700 ",
      "font-medium relative",
      "data-[required]:after:absolute",
      'data-[required]:after:[content:"*"]',
      "data-[required]:after:ml-1",
      "data-[required]:after:mt-0",
      "data-[required]:after:text-red-500",
      "dark:data-[required]:after:text-red-300",
      e
    ),
    ...t
  }
), M = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l(
  o.FormFieldText,
  {
    className: n(s({ size: "sm", variant: "outline" }), e),
    ...t
  }
), j = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l(
  o.FormFieldEmail,
  {
    className: n(s({ size: "sm", variant: "outline" }), e),
    ...t
  }
), _ = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l(
  o.FormFieldFile,
  {
    className: n(
      s({ size: "sm", variant: "outline" }),
      "text-sm pl-2 file:h-full file:cursor-pointer py-0",
      "file:bg-transparent file:border-none file:font-medium",
      "file:text-sm file:text-gray-700 dark:file:text-white-alpha-700",
      e
    ),
    ...t
  }
), G = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l(
  o.FormFieldTextArea,
  {
    className: n(s({ size: "sm", variant: "outline" }), "min-h-20 px-4 py-2", e),
    ...t
  }
), J = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l(
  o.FormFieldCheckbox,
  {
    className: n(i({ slot: "root" }), e),
    ...t
  }
), K = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l(
  o.FormFieldCheckboxIndicator,
  {
    className: n(i({ slot: "indicator" }), e),
    ...t
  }
), O = o.FormFieldSelect, Q = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l(
  o.FormFieldSelectTrigger,
  {
    className: n(r({ slot: "trigger" }), "text-sm", e),
    ...t
  }
), U = o.FormFieldSelectValue, W = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l(
  o.FormFieldSelectIcon,
  {
    className: n("h-4 w-4 opacity-45", e),
    ...t
  }
), X = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l(
  o.FormFieldSelectContent,
  {
    className: n(r({ slot: "content" }), e),
    ...t
  }
), Y = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l(
  o.FormFieldSelectViewport,
  {
    className: n(r({ slot: "viewport" }), e),
    ...t
  }
), Z = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l(
  o.FormFieldSelectItem,
  {
    className: n(r({ slot: "item" }), "text-sm", e),
    ...t
  }
), $ = o.FormFieldSelectItemText, ee = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l(
  o.FormFieldSelectItemIndicator,
  {
    className: n(r({ slot: "itemIndicator" }), e),
    ...t
  }
), te = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l(
  o.FormFieldError,
  {
    className: n("text-sm flex items-center text-red-500 dark:text-red-300", e),
    ...t
  }
), oe = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l(
  o.BotHeading,
  {
    className: n("flex items-center gap-2", e),
    ...t
  }
), le = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l(
  o.BotHeadingIcon,
  {
    className: n(
      "border bg-gradient-to-t",
      "from-gray-100 dark:from-gray-dark-600 p-1 rounded-md",
      "w-6 h-6 text-gray-600 dark:text-white-alpha-700",
      e
    ),
    ...t
  }
), ne = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l(
  o.BotHeadingName,
  {
    className: n("text-gray-800 dark:text-white-alpha-950 text-sm font-semibold", e),
    ...t
  }
), re = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l(
  o.Loading,
  {
    className: n(
      "py-6 flex flex-wrap",
      "gap-x-3 gap-y-6",
      "[&>:first-child]:basis-full text-sm",
      e
    ),
    ...t
  }
), ae = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l(
  o.ConfidentResponse,
  {
    className: n("w-full flex flex-col py-6 gap-6 min-w-0 text-sm", e),
    ...t
  }
), se = ({
  className: e,
  componentStyles: t,
  ...c
}) => /* @__PURE__ */ l(
  o.ConfidentAnswer,
  {
    className: n("max-w-full ", e),
    componentStyles: m(d, t ?? {}),
    ...c
  }
), ie = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l(
  o.ConfidentResponseButton,
  {
    className: n(
      a({ preset: "neutralFilled", size: "sm" }),
      "ml-auto gap-2 data-[escalated]:hidden",
      e
    ),
    ...t
  }
), ce = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l(o.ConfidentResponseButtonIcon, { className: n("", e), ...t }), me = o.ConfidentResponseButtonLabel, de = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l(
  o.SecondaryForm,
  {
    className: n("w-full flex flex-col py-6 gap-6", e),
    ...t
  }
), Fe = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l(
  o.SecondaryFormDescription,
  {
    className: n("text-gray-700 dark:text-white-alpha-700 text-sm", e),
    ...t
  }
), ge = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l(
  o.SecondaryFormFields,
  {
    className: n("w-full gap-8", e),
    ...t
  }
), ue = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l(
  o.SecondaryFormSubmit,
  {
    className: n(
      a({ preset: "neutralFilled", size: "sm" }),
      "ml-auto data-[loading]:cursor-wait",
      "data-[submitted]:hidden",
      e
    ),
    ...t
  }
), Se = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l(
  o.Error,
  {
    className: n("text-red-500 dark:text-red-300", e),
    ...t
  }
), pe = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l(
  o.Sources,
  {
    className: n("w-full flex flex-col gap-6", e),
    ...t
  }
), xe = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l(
  o.SourcesCaption,
  {
    className: n("text-gray-700 dark:text-white-alpha-700 text-sm", e),
    ...t
  }
), fe = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l(
  o.SourcesList,
  {
    className: n("w-full flex flex-wrap gap-2 items-center", e),
    ...t
  }
), Ie = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l(
  o.Source,
  {
    className: n(
      a({ size: "xs", variant: "outline" }),
      "text-gray-600 dark:text-white-alpha-700 gap-1",
      e
    ),
    ...t
  }
), he = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l(o.SourceIcon, { className: n("", e), ...t }), ye = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l(o.SourceTitle, { className: n("line-clamp-1", e), ...t });
export {
  oe as BotHeading,
  le as BotHeadingIcon,
  ne as BotHeadingName,
  J as Checkbox,
  K as CheckboxIndicator,
  se as ConfidentAnswer,
  ae as ConfidentResponse,
  ie as ConfidentResponseButton,
  ce as ConfidentResponseButtonIcon,
  me as ConfidentResponseButtonLabel,
  C as Content,
  w as ContentScrollArea,
  T as ContentScrollAreaCorner,
  A as ContentScrollAreaScrollbar,
  B as ContentScrollAreaThumb,
  k as ContentScrollAreaViewport,
  j as Email,
  Se as Error,
  q as Field,
  te as FieldError,
  D as FieldLabel,
  _ as File,
  b as Heading,
  re as Loading,
  L as PrimaryForm,
  E as PrimaryFormDescription,
  V as PrimaryFormFields,
  z as PrimaryFormSubmit,
  y as Provider,
  N as Root,
  de as SecondaryForm,
  Fe as SecondaryFormDescription,
  ge as SecondaryFormFields,
  ue as SecondaryFormSubmit,
  O as Select,
  X as SelectContent,
  W as SelectIcon,
  Z as SelectItem,
  ee as SelectItemIndicator,
  $ as SelectItemText,
  Q as SelectTrigger,
  U as SelectValue,
  Y as SelectViewport,
  Ie as Source,
  he as SourceIcon,
  ye as SourceTitle,
  pe as Sources,
  xe as SourcesCaption,
  fe as SourcesList,
  P as Success,
  H as SuccessHeading,
  v as SuccessIcon,
  R as SuccessMessage,
  M as Text,
  G as TextArea
};
